"use strict";

import { GlobalParameters } from "generated"
import { toBool } from "../../lib/utils.js";
import { Basic } from "../basic.ts";
import styles from './bimframe.css'
import i18next from "i18next";
/**
 * @class MSBimFrame
 * @extends Basic
 * @classdesc Контейнер Bim модели
 * */
export class MSBimFrame extends Basic {

    static get observedAttributes() {
        return super.observedAttributes.concat(["bimmodels"]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        if (this.id == $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId]) {
            this._pushState = true;
        }
        this.style.userSelect = "none";
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>

            <slot></slot>
            <div class="border border--top"></div>
            <div class="border border--right"></div>
            <div class="border border--bottom"></div>
            <div class="border border--left"></div>
        `;

        this.setInitialBordersValues();

        if (window.ipc) {
            try {
                this.pdfViewer = window.ipc.get().sendSync("server", "getPdf");
            } catch (e) { }
        }
        this._sizetocontent = 1;
        this.firstRun = true;
        this.frameHistory = [];
        this._clientId = Date.now() + Math.floor(Math.random()*10000);
    }

    setInitialBordersValues() {
        this.style.borderWidth = 0;
        this.style.setProperty("--borderThickness", "1px");
        this.style.setProperty("--borderStyle", "solid");
        this.style.setProperty("--borderColor", "GRAY");
    }

    get borderthickness() {
        return this._borderthickness;
    }

    set borderthickness(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) {
            return;
        }
        this._borderthickness = value;
        this.style.setProperty("--borderThickness", this._setValueUnit(value));
    }

    get bordercolor() {
        return this.style.borderColor;
    }

    set bordercolor(value) {
        this.style.setProperty("--borderColor", this.tryToGetUserColor(value));
    }

    get borderstyle() {
        return this._borderstyle;
    }

    set borderstyle(value) {
        this._borderstyle = value;
        this.style.setProperty(
            "--borderStyle",
            this.getBorderStyle(window._enums.BorderStyleType[value])
        );
    }

    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        this.style.display = isShow ? "" : "none";
    }

    updateZIndex(value /*:Number*/) {
        if (value > this.contentMaxZIndex) this.contentMaxZIndex = value;
        if (this._maskElement) {
            this._maskElement.style.zIndex = this.contentMaxZIndex + 1;
        }
        this.style.setProperty("--zIndex", this.contentMaxZIndex);
    }

    get bimmodels() {
        return this._bimmodels;
    }
    set bimmodels(value) {
        this._bimmodels = value;
    }

    setBm(value) {
        if (typeof value !== 'string') {
            return;
        }
        const values = value.split('?');
        const servers = JSON.parse(GlobalParameters.globals.BimServers);
        const serv = `${window.location.protocol}//${servers[values[0]]}`;
        const newvalue = values.length > 1 ? `${serv}?${values[1]}` : `${serv}`;   
        const hasOpenWinAction = this._actionslist && typeof this._actionslist.callopenwindow !== 'undefined';
        const iframe = `<iframe src="${newvalue}&session_id=${$sw.sessionId}&client_id=${this._clientId}&open_window_cmd=${hasOpenWinAction}" style="width:100%;height:100%;"></iframe>`;
        this.innerHTML = iframe;
        this._server = serv;
        this._ipport = servers[values[0]];
    }

    afterInitialize() {
        this.setBm(this._bimmodels);
        this.connectSocket();
        this.timer = setInterval(this.connectSocket.bind(this), 5000);
    }

    connectSocket() {        
        if (!this._socket || this._socket.readyState === 3) {
            const bimframe = this;
            const ws = window.location.protocol.toLowerCase() === "http:" ? "ws" : "wss";
            this._socket = new WebSocket(`${ws}://${this._ipport}/ws/connect?clientId=${this._clientId}`);
            this._socket.onopen = function (e) {
                //Соединение установлено
            };
            this._socket.onmessage = function (event) {
                if (typeof event.data === 'string') {
                    const data = JSON.parse(event.data);
                    switch (data.MessageType) {
                        case "OpenObjectWindowMessage": {
                            if (data.ObjectFullname) {
                                bimframe.callOpenWindow(data.ObjectFullname);
                            }
                            break;
                        }
                    }
                }
            };
            this._socket.onclose = function (event) {
                //if (event.wasClean) {
                //    `Соединение закрыто чисто, код=${event.code} причина=${event.reason}`);
                //} else {
                //    // например, сервер убил процесс или сеть недоступна
                //    // обычно в этом случае event.code 1006
                //    'Соединение прервано'
                //}
            };

            this._socket.onerror = function (error) {
                //Ошибка
            };
        }
    }

    callOpenWindow(objPath) {
        let winPath;
        const paths = objPath.split(".");
        let node = $pr.objTree;
        let wins = {};
        for (let i = 0; i < paths.length; i++) {
            const part = paths[i];
            if (part === i18next.t("pathresolver_resources"))
                continue;
            let child = node[part];
            if (typeof child === "undefined") {
                node = null;
                break;
            }
            if (wins) {
                const newwins = {};
                for (const childwin in wins) {
                    if (childwin.split(".")[0] == child._Name) {
                        newwins[childwin.substring(childwin.indexOf(".") + 1)] = wins[childwin];
                    }
                }
                wins = newwins;
            }

            if ($pr.windMap[child._ID]) {
                for (const win in $pr.windMap[child._ID]) {
                    if (win.includes(".")) {
                        wins[win] = $pr.windMap[child._ID][win];
                    }
                }
            }

            node = child;
        }
        if (node && typeof node._ID !== "undefined") {
            const winsNode = i18next.t("pathresolver_windows");
            if ($pr.windMap[node._ID]) {
                const winName = $pr.getFirstWindow($pr.windMap[node._ID], node._DefaultWindowID);
                if (winName) {
                    winPath = `${objPath}.${winsNode}.${winName}`;
                }
            }
            else {
                //поискать окна в wins
                //если в экземпляре обычный подобъект
                if (wins) {
                    for (const childwin in wins) {
                        if (!node._DefaultWindowID || wins[childwin] == node._DefaultWindowID) {
                            winPath = `${objPath}.${childwin}`;
                            break;
                        }
                    }
                }
            }

            if (winPath) {
                let event = new CustomEvent("callopenwindow", {
                    detail: {
                        windowid: winPath
                        //item: itemPath,
                        //itemtype: itemType
                    },
                });
                this.dispatchEvent(event);
                event = null;
            }
        }    
    }

    /**
     * Метод FocusObject
     */
    FocusObject(e) {
        if (this._socket && this._socket.readyState === 1) {
            const data = {
                ModelName: e.Model ?? "",
                EntityId: e.IFCGUID,
                MessageType: "CameraFocusOnModelMessage"
            };
            this._socket.send(JSON.stringify(data));
        }
        else {
            const title = i18next.t("bim_focus_object_error");
            $ns.add({
                type: "error",
                time: new Date().toLocaleString(),
                title: `${title} ${this._server}`,
                text: i18next.t("bim_no_websocket_connection"),
            });    
        }
    }

    dispose() {
        clearInterval(this.timer);
        if (this._socket && this._socket.readyState !== 2 && this._socket.readyState !== 3)
            this._socket.close();
    }

}